import { Injectable } from '@angular/core';
import { GenericResponse } from '../business-entities/generic-response.class';
import { DataService } from '../services/data.service';
import { Urls } from '../utils/urls';
import { Observable } from 'rxjs';
import { ClientIpViewModel } from '../../../../Widget/src/app/business-entities/client-ip-view-model';

@Injectable({
    providedIn: 'root'
})

export class LanguageDataService
{
    constructor(private dataProvider: DataService) {
    }

    getAllLanguage():Promise<any> {
        return this.dataProvider.GetForLocalization<GenericResponse<any>>(Urls.GetAllLanguages).toPromise();
    } 
    getLocalizationData(languageCode: string): Observable<any>
    {
        return this.dataProvider.Get<GenericResponse<any>>(Urls.GetLocalizationData,languageCode);
    }
    getClientIpData(ip: string): Observable<any>
    {
        return this.dataProvider.Get<GenericResponse<any>>(Urls.GetClientIpDetail,ip);
    }
    addClientIpDetails(clientIpDetails: ClientIpViewModel): Promise<GenericResponse<any>> {
        return this.dataProvider.Post<GenericResponse<any>>(Urls.AddIpDetail, clientIpDetails).toPromise();
    }  
}